import styled, { css } from 'styled-components';
import { colors } from '../../../../theme/style-helpers';
import ChevronLeft from '../../../../assets/icons/ChevronLeft.svg';
import ChevronOrange from '../../../../assets/icons/chevron_right_icon_orange.svg';

export const Label = styled.p`
  font-weight: 500;
  font-size: ${({ size }) => (size === 'small' ? '14px' : '16px')};
  line-height: ${({ size }) => (size === 'small' ? '18px' : '24px')};
  color: ${colors.BLACK};
  margin: 0px;
  width: max-content;
  display: flex;
  align-items: center;

  ${({ $showArrow }) => $showArrow && css`
    background-image: url(${({ isIconLeftPosition }) => (isIconLeftPosition ? ChevronLeft : ChevronOrange)});
    background-repeat: no-repeat;
    background-position: ${({ isIconLeftPosition }) => (isIconLeftPosition ? 'center left' : 'center right')};
    padding-right: ${({ isIconLeftPosition }) => (isIconLeftPosition ? '0px' : '26px')};
    padding-left: ${({ isIconLeftPosition }) => (isIconLeftPosition ? '26px' : '0px')};
  `};
  ${({ $showArrow, iconSrc }) => (!$showArrow && iconSrc) && css`
    background-image: url(${iconSrc});
    background-repeat: no-repeat;
    background-position: ${({ isIconLeftPosition }) => (isIconLeftPosition ? 'center left' : 'center right')};
    padding-right: ${({ isIconLeftPosition }) => (isIconLeftPosition ? '0px' : '26px')};
    padding-left: ${({ isIconLeftPosition }) => (isIconLeftPosition ? '26px' : '0px')};
  `};
`;

export const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ paddingicons }) => (paddingicons ? `${paddingicons}` : '4px 8px')};
  background-color: transparent;
  border-radius: 1px;
  border: none;
  cursor: pointer;
  outline: unset;

  &:hover:enabled {
    ${Label} {
      text-decoration-line: underline;
    }
  }

  &:focus {
    background-color: rgba(255, 95, 20, 0.1);
    outline: unset;
  }

  &:active:enabled {
    ${Label} {
      text-decoration-line: underline;
    }
  }

  &:disabled {
    ${Label} {
      color: ${colors.DARK_GREY};

      ${({ $showArrow, iconSrc, iconSrcDisabled }) => (!$showArrow && iconSrc && iconSrcDisabled) && css`
        background-image: url(${iconSrcDisabled});
      `};
    };

    cursor: not-allowed;
  }

  .icon.left-icon {
    margin-right: 8px;
    height: ${({ iconsheight }) => (iconsheight ? `${iconsheight}` : 'auto')};
  }
`;
